import { render } from "./PhonePart.vue?vue&type=template&id=5b776b5e"
import script from "./PhonePart.vue?vue&type=script&lang=js"
export * from "./PhonePart.vue?vue&type=script&lang=js"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__